export default "/assets/images/social-instagram.svg";